export const rules = {
	// Títulos dos cartões
	"rules.card.rules.title": "Regras",
	"rules.card.goals.title": "Gols",
	"rules.card.cleanSheets.title": "Jogos sem sofrer gols",
	"rules.card.cards.title": "Cartões",
	"rules.card.misc.title": "Diversos",
	"rules.card.captains.title": "Capitães e Vice-Capitães",
	"rules.card.eligibility.title": "Elegibilidade e Prêmios",
	"rules.card.weeklyPrizes.title": "Estrutura de Prêmios Semanais",
	"rules.card.finalRules.title": "Distribuição de Prêmios e Critérios de Desempate",

	// Conteúdo das regras principais
	"rules.intro":
		'Todos os termos em maiúsculas utilizados nestas regras (as <strong>"Regras"</strong>) terão a definição atribuída a eles nos termos e condições (os <strong>"Termos e Condições"</strong>).',

	"rules.rule1":
		"Os participantes podem selecionar sua melhor equipe a cada semana/rodada (conforme o caso), relevante para a competição à qual o jogo Betway Scores BW Fantasy Football se relaciona, por exemplo, Premier League Inglesa, etc. A competição Betway Scores BW Fantasy Football começará em 11 de março de 2025 e será concluída no final da temporada de futebol 2025/2026.",

	"rules.rule2": "Cada semana/rodada corresponde às rodadas daquela liga.",

	"rules.rule3":
		"Os participantes podem selecionar um máximo de dois (2) jogadores por equipe da liga participante para incluir em sua equipe Betway Scores BW Fantasy Football a cada semana/rodada.",

	"rules.rule4":
		"Os participantes precisam selecionar ativamente sua equipe a cada semana/rodada, com a opção de fazer alterações ou escolher manter a mesma equipe para a semana/rodada seguinte.",

	"rules.rule5":
		"Os pontos são alocados da seguinte forma para cada uma das seguintes ações realizadas pelos jogadores que o Participante seleciona em sua equipe Betway Scores BW Fantasy Football a cada semana/rodada:",

	// Pontos de gols
	"rules.goals.forwardGoals": "Gols de atacantes",
	"rules.goals.forwardGoalsValue": "4",
	"rules.goals.midfielderGoals": "Gols de meio-campistas",
	"rules.goals.midfielderGoalsValue": "5",
	"rules.goals.defenderGoals": "Gols de defensores",
	"rules.goals.defenderGoalsValue": "10",
	"rules.goals.goalkeeperGoals": "Gols de goleiros",
	"rules.goals.goalkeeperGoalsValue": "20",
	"rules.goals.penaltyGoals": "Gols de pênalti",
	"rules.goals.penaltyGoalsValue": "3",
	"rules.goals.ownGoals": "Gols contra",
	"rules.goals.ownGoalsValue": "-5",
	"rules.goals.concededGoals": "Gols sofridos",
	"rules.goals.concededGoalsValue": "-1",

	// Pontos de jogos sem sofrer gols
	"rules.cleanSheets.goalkeeperCleanSheet": "Jogo sem sofrer gols do goleiro",
	"rules.cleanSheets.goalkeeperCleanSheetValue": "5",
	"rules.cleanSheets.defenderCleanSheet": "Jogo sem sofrer gols do defensor",
	"rules.cleanSheets.defenderCleanSheetValue": "5",
	"rules.cleanSheets.midfielderCleanSheet": "Jogo sem sofrer gols do meio-campista",
	"rules.cleanSheets.midfielderCleanSheetValue": "1",

	// Pontos de cartões
	"rules.cards.yellowCard": "Cartões amarelos",
	"rules.cards.yellowCardValue": "-2",
	"rules.cards.redCard": "Cartões vermelhos",
	"rules.cards.redCardValue": "-5",

	// Pontos diversos
	"rules.misc.assists": "Assistências",
	"rules.misc.assistsValue": "4",
	"rules.misc.shotsOnTarget": "Chutes no alvo",
	"rules.misc.shotsOnTargetValue": "1",
	"rules.misc.tackles": "Desarmes",
	"rules.misc.tacklesValue": "2",
	"rules.misc.saves": "Defesas",
	"rules.misc.savesValue": "1",
	"rules.misc.minutesOver60": "Minutos jogados igual ou acima de 60",
	"rules.misc.minutesOver60Value": "2",
	"rules.misc.minutesUnder60": "Minutos jogados abaixo de 60",
	"rules.misc.minutesUnder60Value": "1",
	"rules.misc.penaltyWon": "Pênalti conquistado",
	"rules.misc.penaltyWonValue": "3",
	"rules.misc.penaltiesConceded": "Pênalti concedido",
	"rules.misc.penaltiesConcededValue": "-3",
	"rules.misc.penaltyMissed": "Pênalti perdido",
	"rules.misc.penaltyMissedValue": "-3",
	"rules.misc.offsides": "Impedimentos",
	"rules.misc.offsidesValue": "-1",
	"rules.misc.foulsCommitted": "Faltas cometidas",
	"rules.misc.foulsCommittedValue": "-1",

	// Regras de capitão
	"rules.rule6":
		'Os participantes podem designar um <strong>"Capitão"</strong> para sua equipe que receberá 3x pontos. O Capitão pode ser alterado a cada semana/rodada. Se o Capitão for alterado para a semana/rodada seguinte ou mantido para a semana/rodada seguinte, precisa ser selecionado ativamente a cada semana/rodada pelo Participante.',

	"rules.rule7":
		'Os participantes podem designar um <strong>"Vice-Capitão"</strong> para sua equipe que receberá 2x pontos. O Vice-Capitão pode ser alterado a cada semana/rodada. Se o Vice-Capitão for alterado para a semana/rodada seguinte ou mantido para a semana/rodada seguinte, precisa ser selecionado ativamente a cada semana pelo Participante.',

	// Elegibilidade e prêmios
	"rules.rule8":
		"Todos os usuários logados do Betway Scores e/ou BW Scores são elegíveis para jogar BW Fantasy Football, no entanto, apenas participantes com uma conta Betway verificada, no momento em que os prêmios devem ser concedidos, são elegíveis para ganhar prêmios. Mudanças nos resultados das rodadas conforme ponto 2. acima (afetando os pontos sob 5. acima) que ocorrem após a concessão dos prêmios (por exemplo, anulação de resultados de jogos) não serão consideradas retrospectivamente.",

	"rules.rule9":
		"O Participante qualificado e elegível que terminar a temporada em primeiro lugar e tiver uma Conta de Apostas Betway será o vencedor do Grande Prêmio da temporada e ganhará uma viagem para dois (2) para assistir o Arsenal jogar em Londres, incluindo voos (se necessário), acomodação (se necessário) e £500 para gastos.",

	"rules.rule10":
		"Se o vencedor do Grande Prêmio da temporada não puder viajar devido a não ter um passaporte e/ou visto válido e/ou outras limitações, receberá um prêmio de €5.000 em saldo em dinheiro, ou o equivalente aproximado na moeda local na data de início da competição (sendo £4.500, R100.000 ou GH₵ 60.000), em sua Conta Betway no término da competição.",

	"rules.rule11":
		"O vencedor do Grande Prêmio da temporada pode optar por não aceitar a experiência e, em vez disso, aceitar um prêmio de €5.000 em saldo em dinheiro, ou o equivalente aproximado na moeda local na data de início da competição (sendo £4.500, R100.000 ou GH₵ 60.000), em sua Conta Betway.",

	"rules.rule12":
		"Prêmios Semanais serão alocados aos 10 melhores performers a cada semana/rodada que tenham uma Conta de Apostas Betway válida. Se um dos 10 melhores performers não tiver uma Conta de Apostas Betway, não receberá um Prêmio Semanal.",

	"rules.rule13": "As posições semanais de 1 a 10 ganharão os seguintes valores de saldo em dinheiro, dependendo da região, em sua Conta Betway:",

	// Cabeçalhos da tabela de prêmios semanais
	"rules.weeklyPrizes.position": "Posição Por Rodada",
	"rules.weeklyPrizes.eur": "Ganhos em Saldo de Dinheiro (EUR)",
	"rules.weeklyPrizes.gbp": "Ganhos em Saldo de Dinheiro (GBP)",
	"rules.weeklyPrizes.zar": "Ganhos em Saldo de Dinheiro (ZAR)",
	"rules.weeklyPrizes.ghs": "Ganhos em Saldo de Dinheiro (GHS)",

	// Valores dos prêmios semanais
	"rules.weeklyPrizes.1st.eur": "€150",
	"rules.weeklyPrizes.1st.gbp": "£150",
	"rules.weeklyPrizes.1st.zar": "R3000",
	"rules.weeklyPrizes.1st.ghs": "GH₵ 2000",

	"rules.weeklyPrizes.2nd.eur": "€100",
	"rules.weeklyPrizes.2nd.gbp": "£100",
	"rules.weeklyPrizes.2nd.zar": "R2000",
	"rules.weeklyPrizes.2nd.ghs": "GH₵ 1250",

	"rules.weeklyPrizes.3rd.eur": "€75",
	"rules.weeklyPrizes.3rd.gbp": "£75",
	"rules.weeklyPrizes.3rd.zar": "R1500",
	"rules.weeklyPrizes.3rd.ghs": "GH₵ 1000",

	"rules.weeklyPrizes.4th.eur": "€50",
	"rules.weeklyPrizes.4th.gbp": "£50",
	"rules.weeklyPrizes.4th.zar": "R1000",
	"rules.weeklyPrizes.4th.ghs": "GH₵ 600",

	"rules.weeklyPrizes.5th.eur": "€40",
	"rules.weeklyPrizes.5th.gbp": "£40",
	"rules.weeklyPrizes.5th.zar": "R800",
	"rules.weeklyPrizes.5th.ghs": "GH₵ 500",

	"rules.weeklyPrizes.6th.eur": "€30",
	"rules.weeklyPrizes.6th.gbp": "£30",
	"rules.weeklyPrizes.6th.zar": "R600",
	"rules.weeklyPrizes.6th.ghs": "GH₵ 400",

	"rules.weeklyPrizes.7th.eur": "€20",
	"rules.weeklyPrizes.7th.gbp": "£20",
	"rules.weeklyPrizes.7th.zar": "R400",
	"rules.weeklyPrizes.7th.ghs": "GH₵ 250",

	"rules.weeklyPrizes.8th.eur": "€15",
	"rules.weeklyPrizes.8th.gbp": "£15",
	"rules.weeklyPrizes.8th.zar": "R300",
	"rules.weeklyPrizes.8th.ghs": "GH₵ 200",

	"rules.weeklyPrizes.9th.eur": "€10",
	"rules.weeklyPrizes.9th.gbp": "£10",
	"rules.weeklyPrizes.9th.zar": "R200",
	"rules.weeklyPrizes.9th.ghs": "GH₵ 100",

	"rules.weeklyPrizes.10th.eur": "€10",
	"rules.weeklyPrizes.10th.gbp": "£10",
	"rules.weeklyPrizes.10th.zar": "R200",
	"rules.weeklyPrizes.10th.ghs": "GH₵ 100",

	// Regras finais
	"rules.rule14":
		"Os Prêmios Semanais serão concedidos dentro de 7 (sete) dias da finalização dos resultados daquela semana e o Grande Prêmio será concedido dentro de 7 (sete) dias da conclusão da competição Betway Scores BW Fantasy Football.",

	"rules.rule15":
		"Em caso de empate para os Prêmios Semanais, o saldo em dinheiro para aquela posição (e as posições relevantes abaixo dela que são impactadas pelo empate) será dividido igualmente entre os participantes empatados.",

	"rules.rule16":
		"Em caso de empate para o Grande Prêmio, um mecanismo aleatório será usado para selecionar apenas um dos participantes empatados como vencedor do Grande Prêmio.",

	"rules.temporary_notice":
		"Por favor, note que os vencedores de prêmios durante o período de 19 de dezembro de 2025 a 2 de janeiro de 2026 receberão seus prêmios dentro de 7 (sete) dias a partir de 6 de janeiro de 2026",
};
